import { EditSquareIcon } from '../../assets/icons';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

interface Props {
    closeFunc: () => void;
    addFromList: () => void;
    addNewQuestion: () => void;
};

export default function AddRecruitingInterviewNewItem(props: Props) {
    const {
        closeFunc,
        addFromList,
        addNewQuestion,
    } = props;


    const handleAddFromList = () => {
        closeFunc();
        addFromList();
    };

    const handleAddNewQuestion = () => {
        closeFunc();
        addNewQuestion();
    };

    return (
        <Modal
            size='md'
            title='Add new question'
            icon={<EditSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={closeFunc}
        >
            <Button
                type='Outline-Dark'
                text='Add from suggested list'
                className={styles.btn}
                onClick={handleAddFromList}
            />
            <Button
                type='Outline-Dark'
                text='Type new question'
                className={styles.btn}
                onClick={handleAddNewQuestion}
            />
        </Modal>
    )
}
